module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/4_2eff02c1f6d7fdb66ae969713b52a143.png";